// angular
import {Component, OnInit, inject} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
// material angular
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
// components
import {InputComponent} from "@app/core/components/input/input.component";
import {TextareaComponent} from "@app/core/components/textarea/textarea.component";
import {ButtonComponent} from "@app/core/components/button/button.component";
// services
import {WalletService} from "@customer/shared/services/wallet.service";
// directives
import {OnlyNumberDirective} from "@app/core/directives/only-number.directive";
import {CommasSeparateNumbersDirective} from "@app/core/directives/commas-separate-numbers.directive";
import {PreventFormSubmitDirective} from "@app/core/directives/form-enter-handler.directive";
import {AppToastService} from "@app/shared/services/app-toast.service";

@Component({
  selector: "app-initial-debt-dialog",
  templateUrl: "./initial-debt-dialog.component.html",
  styleUrls: ["./initial-debt-dialog.component.scss"],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatCardModule,
    InputComponent,
    TextareaComponent,
    MatButtonModule,
    OnlyNumberDirective,
    CommasSeparateNumbersDirective,
    PreventFormSubmitDirective,
    ButtonComponent,
  ],
})
export class InitialDebtDialogComponent implements OnInit {
  public form: FormGroup;
  public isLoading: boolean = false;

  // dependencies
  private _fb = inject(FormBuilder);
  private _walletService = inject(WalletService);
  private _toastService = inject(AppToastService);
  dialogRef = inject<MatDialogRef<InitialDebtDialogComponent>>(MatDialogRef);
  customerId = inject(MAT_DIALOG_DATA);

  constructor() {}

  ngOnInit() {
    this._buildForm();
  }

  private _buildForm() {
    this.form = this._fb.group({
      initial_balance: new FormControl(null, Validators.required),
      description: new FormControl(null, Validators.required),
    });
  }

  submit() {
    if (this.form.valid) {
      const formData = this.form.value;
      formData.initial_balance =
        Number(formData.initial_balance.replaceAll(",", "")) || null;

      // set loading state
      this.isLoading = true;

      this._walletService.initialBalance(this.customerId, formData).subscribe({
        next: (res) => {
          // fetch data from wallet api
          this.isLoading = false;
          this._toastService.success(
            "wallet.initialBalanceSuccess",
            "toast.success",
            {
              closeButton: false,
              titleClass: "hidden",
            }
          );
          this.dialogRef.close(res);
        },
        error: () => {
          this.isLoading = false;
          this._toastService.error("wallet.initialBalanceFail", "toast.error", {
            closeButton: false,
            titleClass: "hidden",
          });
        },
      });
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
